import axios from 'axios'

axios.interceptors.request.use(config => {
  config.timeout = 960000;
  return config;
});
export default class Relatorios {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/relatorios/`
    this.tokenBearer = tokenBearer
  }

  getFormatos () {
    return new Promise(async (resolve, reject) => {
      let optionsFormatos = {
        method: 'get',
        url: this.url + 'formatos',
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseFormatos = await axios(optionsFormatos)
        resolve(responseFormatos)
      } catch (err) {
        reject(err)
      }
    })
  }

  getTipos (bool = false) {
    return new Promise(async (resolve, reject) => {
      let optionsTipos = {
        method: 'get',
        url: this.url + 'tipos?' + 'mailing=' + bool,
        headers: {
          'Authorization': this.tokenBearer
        }
      }
      try {
        let responseTipos = await axios(optionsTipos)
        resolve(responseTipos)
      } catch (err) {
        reject(err)
      }
    })
  }

  // getCompetencias () {
  //   return new Promise(async (resolve, reject) => {
  //     let optionsTipos = {
  //       method: 'get',
  //       url: this.url + 'competencias',
  //       headers: {
  //         'Authorization': this.tokenBearer
  //       }
  //     }
  //     try {
  //       let competencias = await axios(optionsTipos)
  //       resolve(competencias)
  //     } catch (err) {
  //       reject(err)
  //     }
  //   })
  // }

  exportar (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.url + 'exportar?' + args,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob',
        timeout: 960000
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
